import SimpleLightbox from 'simple-lightbox';

let swiper_lightbox = new SimpleLightbox({
  elements: document.querySelectorAll('.swiper-lightbox a'),
});

import Vue from 'vue';
import VCalendar from 'v-calendar';
import TripCalendar from './components/TripCalendar';

Vue.use(VCalendar);

new Vue({
  el: '#trip-calendar',
  render: h => h(TripCalendar),
});

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import VueI18n from 'vue-i18n';
import BookingForm from './components/BookingForm';

Vue.use(VueSweetalert2);

let vue_recaptcha_options = {
  siteKey: window.trip_post_script_data.google_recaptcha_site_key,
  loaderOptions: {
    autoHideBadge: false,
    explicitRenderParameters: {
      badge: 'bottomleft',
      size: 'invisible',
    }
  }
};

Vue.use(VueReCaptcha, vue_recaptcha_options);

Vue.use(VueI18n);

const messages = {
  'en_NZ': {
    message: {
      trip_booking_error_1: window.trip_post_script_data.trip_booking_error_1,
      trip_booking_error_2: window.trip_post_script_data.trip_booking_error_2,
      trip_booking_error_3: window.trip_post_script_data.trip_booking_error_3,
      trip_booking_error_4: window.trip_post_script_data.trip_booking_error_4,
      trip_booking_error_5: window.trip_post_script_data.trip_booking_error_5,
      trip_booking_error_6: window.trip_post_script_data.trip_booking_error_6,
      trip_booking_error_7: window.trip_post_script_data.trip_booking_error_7,
      trip_booking_error_8: window.trip_post_script_data.trip_booking_error_8,
      trip_booking_error_9: window.trip_post_script_data.trip_booking_error_9,
    }
  },
  'zh_CN': {
    message: {
      trip_booking_error_1: window.trip_post_script_data.trip_booking_error_1,
      trip_booking_error_2: window.trip_post_script_data.trip_booking_error_2,
      trip_booking_error_3: window.trip_post_script_data.trip_booking_error_3,
      trip_booking_error_4: window.trip_post_script_data.trip_booking_error_4,
      trip_booking_error_5: window.trip_post_script_data.trip_booking_error_5,
      trip_booking_error_6: window.trip_post_script_data.trip_booking_error_6,
      trip_booking_error_7: window.trip_post_script_data.trip_booking_error_7,
      trip_booking_error_8: window.trip_post_script_data.trip_booking_error_8,
      trip_booking_error_9: window.trip_post_script_data.trip_booking_error_9,
    }
  }
};

const i18n = new VueI18n({
  locale: window.trip_post_script_data.locale,
  messages,
});

new Vue({
  el: '#booking',
  render: h => h(BookingForm, VCalendar),
  i18n,
});

i18n.locale = window.trip_post_script_data.locale;
